<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m — Emissão: Novos em massa
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  emitir várias Ordens de Serviço de uma vez
        |  para fiscais de um
        strong  grupo de usuários
        | . Serão criados
        code  quantidade × fiscais selecionados
        |  serviços.

      .toast.toast-primary
        | A opção
        strong  Novos em massa
        |  exige a permissão
        strong  Ordem serviços → Criar serviços em massa
        | .

      h5.h5 1. Abrir o formulário
      ol
        li Em
          strong  OS-m → Serviços
          | , clique no
          strong  +
          | .
        li Escolha
          strong  Novos em massa
          | .
      figure.manual-figure
        img(:src="imgMenu" alt="Menu + com opções de emissão de OS")

      h5.h5 2. Preencher Novos serviços em massa
      figure.manual-figure
        img(:src="imgForm" alt="Formulário Novos serviços em massa")
      ol
        li
          strong Quantidade
          |  (obrigatório) — quantas OS criar
          em por fiscal
          |  selecionado.
        li
          strong Assunto
          |  (obrigatório).
        li
          strong Grupo de usuários
          |  (obrigatório) — após escolher o grupo, marque os
          strong  fiscais
          |  que receberão as OS.
        li
          strong Analista
          |  — se o assunto permitir análise.
        li
          strong Protocolo
          | , 
          strong Prazo
          |  e
          strong  É necessário agendar
          | .
        li
          strong Observações
          |  (obrigatório).

      h5.h5 3. Salvar
      ol
        li Clique em
          strong  Salvar
          | .
        li O sistema cria as OS em lote conforme a quantidade e os fiscais
          |  selecionados.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMenu: require("@/assets/manuais/06-osm-emissao-menu.png"),
      imgForm: require("@/assets/manuais/06c-osm-emissao-massa.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
